









































































import { Component, Prop, Vue } from "vue-property-decorator";
import QuestionAnswer from "./question-answer.vue";
import Results from "./results.vue";
import {
  calculateEaseOfImplementation,
  calculateBenefitSuitability,
  calculateBandwidthFreed,
  calculateErrorReduction,
  calculateEffortToImplement,
  calculateOverallStability,
  calculateFullTimeEquivalentNeededToPerform,
  calculateAverageHandlingTimeReduction,
  ProcessFrequency,
  InputDataStructure,
  ProcessStability,
  ProcessSteps,
  AmountOfStructuredInputData,
  InputScanned,
  RemoteDesktopApplication,
  ApplicationsUsed,
  DecisionDifficulty,
  ProcessPeaks,
  NoneFeasabilityResult,
  ApplicationStability
} from "../store/assessment.calc";
import {
  IAssessment,
  IAssessmentInputs,
  IQuestion,
  IAssessmentOutputs,
  IQuestionSet
} from "../store/main.interfaces";
import {
  makeEmptyAssessmentObject,
  makeInputsFromQuestions
} from "../store/assessment.util";
import assessments from "../store/modules/assessments";
import { getQuestions } from "../store/questions";
import { assembleAssessmentOutputs } from "../store/assessment.assembly";
import AutoCompleteTextField from "@/components/autocomplete-text-field.vue";

let entries: IAssessment[] = [];

@Component({
  components: { QuestionAnswer, Results, AutoCompleteTextField }
})
export default class DetailQuestions extends Vue {
  @Prop({ default: () => makeEmptyAssessmentObject() })
  editableAssessment!: IAssessment;

  editableAssessmentCopy: IAssessment | null = null;

  questions: IQuestionSet = getQuestions();

  noNameAlert: boolean = false;
  failedCreationOrUpdateAlert: boolean = false;

  get availableDepartments() {
    return assessments.allDepartments;
  }

  async saveAssessment() {
    this.editableAssessmentCopy = {
      ...(this.editableAssessmentCopy! as any),
      inputs: makeInputsFromQuestions(this.questions),
      outputs: this.getCalculatedAssessmentOutputs()
    };
    if (
      this.editableAssessmentCopy != null &&
      this.editableAssessmentCopy.name !== undefined &&
      this.editableAssessmentCopy.name !== ""
    ) {
      const createdOrUpdatedAssessment = await assessments.createOrUpdateAssessment(
        this.editableAssessmentCopy
      );
      if (createdOrUpdatedAssessment.name !== undefined) {
        this.$emit("updateAssessment", createdOrUpdatedAssessment);
      } else {
        this.failedCreationOrUpdateAlert = true;
      }
    } else {
      this.noNameAlert = true;
    }
  }
  cancel() {
    this.$emit("updateAssessment", undefined);
  }
  updateAnswer(questionIndex: keyof IQuestionSet, answerValue: number) {
    this.questions[questionIndex].answerValue = answerValue;
  }
  getDataToEdit() {
    if (this.editableAssessment) {
      this.editableAssessmentCopy = JSON.parse(
        JSON.stringify(this.editableAssessment)
      );
      this.questions = getQuestions();
      for (const key in this.questions) {
        const assessmentKey: keyof IAssessmentInputs = key as keyof IAssessmentInputs;
        this.questions[
          assessmentKey
        ].answerValue = this.editableAssessmentCopy!.inputs[assessmentKey];
      }
    }
  }
  created() {
    this.getDataToEdit();
  }
  getCalculatedAssessmentOutputs(): IAssessment {
    const inputs = makeInputsFromQuestions(this.questions);
    const assessmentOutputs: IAssessmentOutputs = assembleAssessmentOutputs(
      inputs
    );
    return { outputs: assessmentOutputs, inputs, name: "" } as IAssessment;
  }
}
